import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

// Live configuration
const firebaseConfig = {
  apiKey: "AIzaSyDkMb4eg4rtrk8_RqlN_CQca7Hwf5Sc2sc",
  authDomain: "apeejay-parent-app.firebaseapp.com",
  projectId: "apeejay-parent-app",
  storageBucket: "apeejay-parent-app.firebasestorage.app",
  messagingSenderId: "880183245504",
  appId: "1:880183245504:web:51dde39bf4e6980af98b25",
  measurementId: "G-B7HJH2XL58"
};

const app = initializeApp(firebaseConfig);

let messaging = null;

// Only initialize messaging if supported
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
  }
});

export { messaging };


